(ns fablo-offers.common.api
  (:require
   [fablo-offers.config-static :as cfg]
   [lambdaisland.glogi :as log]
   [cljs-bean.transit]
   [cognitect.transit]
   [lambdaisland.fetch :as fetch]
   [cljs.reader :as edn]
   [time-literals.read-write]
   [promesa.core :as p]))

(time-literals.read-write/print-time-literals-cljs!)

(defn auth-header [auth-token]
  (when auth-token
    {"Authorization" (str "Token " auth-token)}))

(defn query-id->path [x]
  (-> x
      str
      (.replace #"^:" "")))

(defn fetch [query-id entity-id-or-params]
  (when query-id
    (let [entity-id (when (string? entity-id-or-params) entity-id-or-params)
          params (when (map? entity-id-or-params) entity-id-or-params)
          auth-token (:auth-token params)
          params (dissoc params :auth-token)]
      ;(js/console.log "fetch'" query-id entity-id-or-params)
      (p/->
       (fetch/get
        (str cfg/api-url
             "/fetch/"
             (query-id->path query-id)
             (when entity-id
               (str "/" entity-id)))
        {:headers (auth-header auth-token)
         :query-params params
         :transit-json-reader (cognitect.transit/reader :json {:handlers
                                                               {"edn" #(edn/read-string {:readers time-literals.read-write/tags} %)}})})
       (p/then (fn [res]
                 ;(js/console.log "RES" (:body res))
                 (if (<= 200 (:status res) 299)
                   (:body res)
                   (p/rejected res))))))))

(def edn-writer
  (cognitect.transit/write-handler (constantly "edn") #(pr-str %)))

(defn tx [tx-id params]
  (log/info :tx-id tx-id :params params)
  (let [auth-token (:auth-token params)
        params (dissoc params :auth-token)]
    (->
     (fetch/post
      (str cfg/api-url
           "/tx/"
           (query-id->path tx-id))
      {:headers (auth-header auth-token)
       :body params
       :transit-json-reader (cognitect.transit/reader :json {:handlers
                                                             {"edn" #(edn/read-string {:readers time-literals.read-write/tags} %)}})
       :transit-json-writer (cognitect.transit/writer :json {:handlers (merge (cljs-bean.transit/writer-handlers)
                                                                              {js/java.time.DayOfWeek edn-writer
                                                                               js/java.time.LocalDate edn-writer
                                                                               js/java.time.LocalTime edn-writer
                                                                               js/java.time.Duration  edn-writer})})})
     (p/then (fn [res]
               (if (<= 200 (:status res) 299)
                 (:body res)
                 (p/rejected res)))))))
